import {
  type BorderRadius,
  type DynamicSize,
} from 'fitify-ui/src/theme/generated/theme-variables'

import type { themeColors } from '../theme/generated/theme-colors'

// Combining old with new themes to have all necessary semantic colors
type SemanticColors = (typeof themeColors)[FigmaColorTheme.BlueLight]

export enum FigmaColorTheme {
  BlueDark = 'Blue Dark',
  BlueLight = 'Blue Light',
  BrownLight = 'Brown Light',
  CoolGreyDark = 'Cool Grey Dark',
  CoralLight = 'Coral Light',
  EmeraldGreenLight = 'Emerald Green Light',
  SandMilitaryDark = 'Sand Military Dark',
  SandMilitaryLight = 'Sand Military Light',
  SoftOrchidLight = 'Soft Orchid Light',
  SoftPeriwinkleLight = 'Soft Periwinkle Light',
}

export enum ColorTheme {
  BlueDark = 'blue-dark',
  BlueLight = 'blue-light',
  BrownLight = 'brown-light',
  CoolGreyDark = 'cool-grey-dark',
  CoralLight = 'coral-light',
  EmeraldGreenLight = 'emerald-green-light',
  SandMilitaryDark = 'sand-military-dark',
  SandMilitaryLight = 'sand-military-light',
  SoftOrchidLight = 'soft-orchid-light',
  SoftPeriwinkleLight = 'soft-periwinkle-light',
}

export type ThemeFonts = {
  heading: string
  text: string
}

export type ThemeSizes = {
  contentHorizontalPadding: number
  contentWidth: number
  headerHeight: number
}

export type Theme = {
  colors: SemanticColors
  dynamicSizes: DynamicSize
  fonts: ThemeFonts
  isDarkTheme: boolean
  radius: BorderRadius
  sizes: ThemeSizes
  type: ColorTheme
}
